import {
  UserCheck,
  MessageCircle,
  CalendarDays,
  Target,
  Compass,
  TrendingUp,
} from "lucide-react";

const approaches = [
  {
    icon: UserCheck,
    title: "Small Batch",
    desc: "Maximum 30 students per cohort",
  },
  {
    icon: MessageCircle,
    title: "Personal Mentorship",
    desc: "Direct doubt resolution and guidance",
  },
  {
    icon: CalendarDays,
    title: "Structured Study Plan",
    desc: "Weekly organized study roadmap",
  },
  {
    icon: Target,
    title: "Mock Test Analysis",
    desc: "Detailed performance breakdowns",
  },
  {
    icon: TrendingUp,
    title: "Strategy-First",
    desc: "Preparation built on proven strategy",
  },
  {
    icon: Compass,
    title: "Career Clarity",
    desc: "Long-term career direction focus",
  },
];

export default function ApproachSection() {
  return (
    <section
      id="approach"
      data-testid="approach-section"
      className="py-20 md:py-32 bg-orange-50/40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="max-w-2xl">
          <span className="text-sm font-semibold tracking-wider uppercase text-orange-600 font-body">
            Our Approach
          </span>
          <h2
            data-testid="approach-title"
            className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-zinc-900 tracking-tight leading-tight mt-4"
          >
            How The Obiter Is Different
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
          {approaches.map((item, idx) => (
            <div
              key={idx}
              data-testid={`approach-card-${idx}`}
              className="card-hover bg-white p-8 rounded-2xl border border-zinc-100"
            >
              <div className="w-12 h-12 rounded-xl bg-orange-50 flex items-center justify-center mb-5">
                <item.icon
                  size={22}
                  strokeWidth={1.5}
                  className="text-orange-600"
                />
              </div>
              <h3 className="font-heading text-lg font-semibold text-zinc-900 mb-2">
                {item.title}
              </h3>
              <p className="font-body text-sm text-zinc-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
